import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { banLog, banUser, serverList } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
import logdetails from "./components/logdetails.vue";
export default {
  name: "blockedLog",
  mixins: [gmTool],
  components: {
    logdetails: logdetails
  },
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      // 表格数据
      tableCopyTableList: [],
      // 表格copy数据b
      value1: '',
      paramsData: {
        page: 1,
        role_id: ''
      },
      serverLists: [],
      total: 0
    };
  },
  created: function created() {// this.getList(1)
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.reqLoading = true;
                _this2.paramsData.page = e;
                banLog(_this2.paramsData).then(function (res) {
                  if (res.status == 200) {
                    _this2.tableData = res.data.result;
                    _this2.total = res.data.total;
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    Renewal: function Renewal() {
      this.getList(1);
    }
  }
};